export const userLogout = () => {
  return {
    type: 'USER_LOGOUT'
  };
};
